import React, { useState } from "react";
import UncannyValleyGame from "./UncannyValleyGame";
import CardsPage from "./CardsPage";
import AboutPage from "./AboutPage";
import Rules from "./Rules";


export default function ToggleView() {
  const [view, setView] = useState("about");

  return (
    <div className="p-4">
      <div className="mb-4 space-x-2">

      <button
          onClick={() => setView("about")}
          style={{
            padding: '0.5rem 1rem',
            textDecoration: 'none',
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '5px',
            fontWeight: 'bold',
            marginRight: "8px"
          }}
        >
          About
        </button>

        <button
          onClick={() => setView("game")}
          style={{
            padding: '0.5rem 1rem',
            textDecoration: 'none',
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '5px',
            fontWeight: 'bold',
            marginRight: "8px"
          }}
        >
          Play
        </button>

        <button
          onClick={() => setView("cards")}
          style={{
            padding: '0.5rem 1rem',
            textDecoration: 'none',
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '5px',
            fontWeight: 'bold',
            marginRight: "8px"
          }}
        >
          Cards
        </button>

        <button
          onClick={() => setView("rules")}
          style={{
            padding: '0.5rem 1rem',
            textDecoration: 'none',
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '5px',
            fontWeight: 'bold',
            marginRight: "8px"
          }}
        >
          Rules
        </button>

     

      </div>

      {view === "about" && (
        <div style={{ width: "100%" }}>
          <AboutPage />
        </div>
      )}
      
      {view === "game" && (
        <div style={{ width: "100%" }}>
          <UncannyValleyGame />
        </div>
      )}

      {view === "cards" && (
        <div style={{ width: "100%" }}>
          <CardsPage />
        </div>
      )}

      {view === "rules" && (
        <div style={{ width: "100%" }}>
          <Rules />
        </div>
      )}

    
    </div>
  );
}

